import * as React from 'react';
export const useIsOverflow = ({ ref, callback, direction = 'horizontal', extraDependency }) => {
    const [isOverflow, setIsOverflow] = React.useState(false);
    React.useLayoutEffect(() => {
        const { current } = ref;
        if (!current)
            return;
        const checkOverflow = () => {
            let hasOverflow;
            if (direction === 'vertical') {
                hasOverflow = current.scrollHeight > current.clientHeight;
            }
            else {
                hasOverflow = current.scrollWidth > current.clientWidth;
            }
            setIsOverflow(hasOverflow);
            if (callback)
                callback(hasOverflow);
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        resizeObserver.observe(current);
        const mutationObserver = new MutationObserver(checkOverflow);
        mutationObserver.observe(current, {
            childList: true,
            subtree: true,
            characterData: true,
        });
        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [callback, ref, direction, extraDependency]);
    return isOverflow;
};
